import {Component, React, observer} from '$src/handy'
import * as css from './HCStatusButton.css'
import GenericButton from '$src/common/GenericButton'
import {HousingCorporation} from '$src/bootstrap/Store'
import EditCommentModal from '$src/housingCorporations/EditCommentModal'

interface Props {
  css?: any
  housingCorporation: typeof HousingCorporation.Type
}

interface State {
  modalOpen: boolean
  optimisticState: null | boolean
}

function truncate(string: string, len: number) {
  if (string.length > len) return string.substring(0, len) + '...'
  else return string
}

@observer
export default class CommentButton extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      modalOpen: false,
      optimisticState: null,
    }
  }

  render() {
    const {props} = this
    const {housingCorporation} = props
    const {comment} = housingCorporation
    const hasComment = typeof comment === 'string' && comment.trim().length > 0

    return (
      <GenericButton
        variant="round"
        withMargin
        css={{container: css.button}}
        onClick={this.buttonClick}
      >
        {hasComment ? truncate(comment as string, 34) : 'No comment'}
        {this.state.modalOpen && (
          <EditCommentModal
            cid={housingCorporation._id}
            onRequestClose={this.closeModal}
            onUpdateNeeded={(comment: string) => {
              housingCorporation.setComment(comment)
            }}
          />
        )}
      </GenericButton>
    )
  }

  closeModal = () => {
    this.setState({modalOpen: false})
  }

  buttonClick = async () => {
    this.setState({modalOpen: true})
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/CommentButton.tsx